export const NO_PERMISSIONS = Object.freeze({
  backofficeRead: false, backofficeWrite: false, companyScreens: false, admin: false, campaigns: false, continuousImprovement: false, funding: false,
});

// Concessões somáveis ao papel (spec §6.5, A13). Mesmas chaves do BE (PUT antecipeadmin/access/users/:id/grants);
// mesma ordem canônica do BE (domain/grants.ts).
export const GRANT_KEYS = ["campaigns", "continuous_improvement", "funding"];
export const GRANT_LABELS = { continuous_improvement: "Melhoria contínua", campaigns: "Campanhas", funding: "Funding" };

export const normalizePermissions = (permissions) => {
  const admin = permissions?.admin === true;
  return {
    backofficeRead: permissions?.backofficeRead === true,
    backofficeWrite: permissions?.backofficeWrite === true,
    companyScreens: permissions?.companyScreens === true,
    admin,
    // A13: Admin implica todas as concessões (o BE já devolve assim no /auth/me; aqui é defesa).
    campaigns: admin || permissions?.campaigns === true,
    continuousImprovement: admin || permissions?.continuousImprovement === true,
    funding: admin || permissions?.funding === true,
  };
};

export const hasPermission = (permissions, required) => !required || normalizePermissions(permissions)[required] === true;

// Mesma ordem do menu único (comum-menu-gestor-operador.png).
const HOME_BY_PERMISSION = [
  ["companyScreens", "/admin/empresa/solicitacoes"],
  ["backofficeRead", "/admin/antecipe/solicitacoes"],
  ["admin", "/admin/acessos"],
];

export const getHomePath = (me) => {
  const permissions = normalizePermissions(me?.permissions);
  const hit = HOME_BY_PERMISSION.find(([key]) => permissions[key]);
  return hit ? hit[1] : null;
};

const ROLE_NAMES = { admin: "Admin", operator: "Operador", reader: "Leitura" };
export const roleName = (role) => ROLE_NAMES[role] || null;

export const badgeLabel = (me) => {
  const parts = [];
  const role = roleName(me?.role);
  if (role) parts.push(role);
  const count = me?.companies?.length || 0;
  if (count) parts.push(`Gestor de ${count} ${count === 1 ? "empresa" : "empresas"}`);
  return parts.join(" · ");
};

export const initials = (name, email) => {
  const words = (name || "").trim().split(/\s+/).filter(Boolean);
  if (words.length) return words.slice(0, 2).map((w) => w[0]).join("").toUpperCase();
  const first = (email || "").trim()[0];
  return first ? first.toUpperCase() : "?";
};
